/**
 * Get iovation blackbox data.
 * @returns {{blackbox: string, finished: boolean}}
 */
export function getIovationValues() {
    const { blackbox, finished } = window?.IGLOO?.getBlackbox?.() || {};

    return { blackbox, finished };
}
